export class TimeSpanUtils {

    static FromDays(n): number {
        if (typeof n !== 'number') {
            return 0;
        }
        return Math.abs(n) * 1000 * 60 * 60 * 24;
    }

    static FromHours(n): number {
        if (typeof n !== 'number') {
            return 0;
        }
        return Math.abs(n) * 1000 * 60 * 60;
    }

    static FromMinutes(n): number {
        if (typeof n !== 'number') {
            return 0;
        }
        return Math.abs(n) * 1000 * 60;
    }

    static FromSeconds(n): number {
        if (typeof n !== 'number') {
            return 0;
        }
        return Math.abs(n) * 1000;
    }

    static MsToMinutes(ms): number {
        return Math.floor(ms / 60000);
    }

    static MsToHours(ms): number {
        return Math.floor(ms / 36000);
    }
}
